import * as Scrivito from "scrivito";

// This is just a dummy class so prerender works correctly while in development.
Scrivito.provideObjClass("FavouriteCoursesPage", {
  onlyInside: "DoesNotExist",
});
